// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
		numberFilterTree: 2,
		paginationType: boostPFSConfig.custom.infinite_scroll ? 'infinite' : 'default',
		filterTreeMobileStyle: 'style1'
	},
	selectors: {
		breadcrumb: '#breadcrumb', // Selector for breadcrumb
		trackingQuickView: '[data-fancybox="quick-view"]' , // Defaut is '',
		trackingAddToCart: 'form[action="/cart/add"] *[type="submit"]', // Default is 'form[action="/cart/add"] *[type="submit"]',
		trackingBuyNow: '.shopify-payment-button, #dynamic-checkout-cart' // Default is '.shopify-payment-button, #dynamic-checkout-cart'
	}
};
  
var boostPFSTemplate = {
    'saleLabelHtml': '<div class="sale-item icn">' + boostPFSConfig.label.sale + '</div>',
    'soldOutLabelHtml': '<div class="so icn">' + boostPFSConfig.label.sold_out + '</div>',
    'newLabelHtml': '<div class="new icn">' + boostPFSConfig.label.new + '</div>',
    'vendorHtml': '<h4>{{itemVendorLabel}}</h4>',
    'quickViewHtml': '<a class="fancybox.ajax product-modal" rel="nofollow" href="{{itemUrl}}?view=quick">' + boostPFSConfig.label.quick_view + '</a>',
    'imageFlipHtml': '<div class="hidden"><img src="{{imageFlipUrl}}" alt="{{itemTitle}}" /></div>',

    // Grid Template
    'productGridItemHtml':  '<div id="prod-{{itemId}}" class="product {{itemGridWidthClass}} tablet-half mobile-half" data-alpha="{{itemTitle}}" data-price="{{itemPriceNumber}}">' +
                                '<div class="ci">' +
                                    '{{itemNewLabel}}' +
                                    '{{itemSaleLabel}}' +
                                    '{{itemSoldoutLabel}}' +

                                    '<a href="{{itemUrl}}" title="{{itemTitle}}">' +
                                        '<div class="reveal">' +
                                            '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}" />' +
                                            '{{itemImageFlip}}' +
                                        '</div>' +
                                    '</a>' +
                                '</div>' +

                                '<div class="product-info">' +
                                    '{{itemQuickView}}' +
                                '</div>' +

                                '<div class="product-details">' +
                                    '<a href="{{itemUrl}}">' +
                                        '<h3>{{itemTitle}}</h3>' +
                                        '{{itemVendor}}' +
                                    '</a>' +
                                    '<div class="price">{{itemPrice}}</div>' +
                                '</div>' +
                            '</div>',

    // Pagination Template
    'previousHtml': '<a href="{{itemUrl}}"><</a>',
    'nextHtml': '<a href="{{itemUrl}}">></a>',
    'pageItemHtml': '<a href="{{itemUrl}}">{{itemTitle}}</a>',
    'pageItemSelectedHtml': '<span class="current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
    'paginateHtml': '<div id="pagination" class="desktop-12 mobile-3"><span class="count"></span>{{previous}}{{pageItems}}{{next}}</div>',

    // Sorting Template
    'sortingHtml': '<select id="sort-by" class="styled-select">{{sortingItems}}</select>',
};


(function() {
	BoostPFS.inject(this);
  
	ProductGridItem.prototype.compileTemplate = function (data, index, totalProduct) {
		if (!data) data = this.data;  // Add this line
		if (!index) index = this.index;  // Add this line
		if (!totalProduct) totalProduct = this.totalProduct;  // Add this line
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add itemGridWidthClass
        var itemGridWidthClass = '';
        var productsPerRow = boostPFSConfig.custom.products_per_row;
        switch (productsPerRow) {
            case 4: itemGridWidthClass = buildItemGridClass('desktop-3', index, productsPerRow); break;
            case 3: itemGridWidthClass = buildItemGridClass('desktop-4', index, productsPerRow); break;
            default: break;
        }
        itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

        // Add Label
        var itemNewLabelHtml = '';
        var itemSaleLabelHtml = '';
        var itemSoldoutLabelHtml = '';
        if (!soldOut) {
            for (var k in data.collections) {
                if (data['collections'][k]['handle'] == 'new') {
                    itemNewLabelHtml = boostPFSTemplate.newLabelHtml;
                    break;
                }
            }
            if (onSale) {
                itemSaleLabelHtml = boostPFSTemplate.saleLabelHtml;
            }
        } else {
            itemSoldoutLabelHtml = boostPFSTemplate.soldOutLabelHtml;
        }
        itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
        itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
        itemHtml = itemHtml.replace(/{{itemSoldoutLabel}}/g, itemSoldoutLabelHtml);

        // Add Vendor
        var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

        // Add price
        var itemPriceHtml = '';
        if (onSale) {
            itemPriceHtml += '<div class="onsale"><span class="money">' + Utils.formatMoney(data.price_min, Settings.shop.money_format) + '</span></div>';
            itemPriceHtml += '<div class="was-listing"><span class="money">' + Utils.formatMoney(data.compare_at_price_min, Settings.shop.money_format) + '</span></div>'
        } else {
            itemPriceHtml += '<div class="prod-price">';
            if (priceVaries) {
                itemPriceHtml += boostPFSConfig.label.from_price + ' <span class="money">' + Utils.formatMoney(data.price_min, Settings.shop.money_format) + '</span> - <span class="money">' + Utils.formatMoney(data.price_max, Settings.shop.money_format) + '</span>';
            } else {
                itemPriceHtml += '<span class="money">' + Utils.formatMoney(data.price_min, Settings.shop.money_format) + '</span>';
            }
            itemPriceHtml += '</div>';
        }
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

        // Add Thumbnail
        var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '305x457') : boostPFSConfig.general.no_image_url;
        itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

        // Add Image Flip
        var itemImageFlipHtml = '';
        if (boostPFSConfig.custom.image_flip_enable && images.length > 1) { 
            itemImageFlipHtml = (boostPFSTemplate.imageFlipHtml).replace(/{{imageFlipUrl}}/g, Utils.optimizeImage(images[1]['src']));
        }
        itemHtml = itemHtml.replace(/{{itemImageFlip}}/g, itemImageFlipHtml);

        // Add Quick view
        var itemQuickViewHtml = boostPFSConfig.custom.quick_view_enable ? boostPFSTemplate.quickViewHtml : '';
        itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);    

        // Add main attribute
        itemHtml = itemHtml.replace(/{{itemPriceNumber}}/g, Utils.formatMoney(data.price_min, Settings.shop.money_format));
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

        return itemHtml;
	}

	function buildItemGridClass(itemClass, index, productsPerRow) {
      	index++;
      
        var temp = index < productsPerRow ? index : index % productsPerRow;
        if (temp == 1) { itemClass += ' first'; }
        else if (temp == 0) { itemClass += ' last'; };
        return itemClass;
    }

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function () {
		var totalProduct = this.data.total_product
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (Settings.getSettingValue('general.paginationType') == 'default' && totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build wrapper
			paginationHtml = paginationHtml.replace(/{{paginateWrapperClass}}/g, 'twelve');

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content 
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
				return html;
			}
		}
	};
		

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function () { 
		Currency.convertAll(boostPFSConfig.shop.currency, jQ('.currency-picker').val());
	};

	// Capitalize label of filter option
	FilterResult.prototype.afterRender = function () {
		var data = this.data;
		
		var from = Globals.queryParams.page == 1 ? Globals.queryParams.page : (Globals.queryParams.page - 1) * Globals.queryParams.limit + 1;
		var to = from + data.products.length - 1;
		jQ(Selector.bottomPagination).find('.count').html(boostPFSConfig.label.showing_items + ' ' + from + '-' + to + ' / ' + data.total_product);

		if (window.SPR) {
		SPR.initDomEls();
		SPR.loadBadges();
		}

	}; 

})();